module.exports = __webpack_public_path__ + "static/media/flip-flop.00f29223.jpg";